import React from 'react';
import Axios from 'axios';
import ShopProfile from './shopProfile';

export default class PopUp extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            popUp: false
        }
    }

    getCookie(c_name) {
        var c_value = document.cookie,
            c_start = c_value.indexOf(" " + c_name + "=");
        if (c_start === -1) c_start = c_value.indexOf(c_name + "=");
        if (c_start === -1) {
            c_value = 0;
        } else {
            c_start = c_value.indexOf("=", c_start) + 1;
            var c_end = c_value.indexOf(";", c_start);
            if (c_end === -1) {
                c_end = c_value.length;
            }
            c_value = unescape(c_value.substring(c_start, c_end));
        }
        return c_value;
    }

    popUpInfo() {
        //var { popUp } = this.state;
        const pop = new PopUp().getCookie('__POP');
        //Ezt belerakom, hogy ne fusson sokszor a feach
        var active = ShopProfile.getPopUpActive();
        var popUpPicName = ShopProfile.getPopUpPicName();
        if (popUpPicName === '' && pop === 0 && active === true) {
            ShopProfile.setPopUpActive(false);
            var url = ShopProfile.getURL() + '/index/reactFetch.php';
            var data = new URLSearchParams({
                event: 'popup',
                reverse: false
            });
            Axios.post(url, data)
                .then(res => {
                    //ShopProfile.setPopUpActive(false);
                    ShopProfile.setPopUpName(res.data['name']);
                    ShopProfile.setPopUpPicName(res.data['picName']);
                    ShopProfile.setPopUpDesc(res.data['desc']);
                    ShopProfile.setPopUpLink(res.data['link']);
                });
            setTimeout(function () {
                document.cookie = '__POP=OK' + ';path=/;SameSite=Lax';
            }, 2000);
        }
        return popUpPicName;
    }

    popUpHide() {
        var overlay = document.getElementById('overlay');
        overlay.remove();
        var popUpShow = document.getElementById('popUpBox');
        popUpShow.remove();
        var popUpClose = document.getElementById('popUpBoxClose');
        popUpClose.remove();
    }

    /*addElement(name, text, call) {
        var div = document.createElement('div');
        div.id = name;
        if (text !== '') {
            div.innerHTML = text;
        }
        if (call !== '') {
            div.addEventListener("click", function () {
                this.popUpHide();
            });
        }
        document.body.appendChild(div);
    }

    popUpCreat() {
        this.addElement('overlay', '', 'click');
        this.addElement('popUpShow', '', '');
        this.addElement('popUpClose', '<b><i>X</i></b>', 'click');
    }*/

    popUpPic() {
        var url = ShopProfile.getURL() + '/image/popUp/' + ShopProfile.getPopUpPicName() + '.jpg';
        var name = ShopProfile.getPopUpName();
        return (
            <img src={url} alt={name} />
        )
    }

    popUpPicOnclick() {
        var url = ShopProfile.getURL() + '/image/popUp/' + ShopProfile.getPopUpPicName() + '.jpg';
        var name = ShopProfile.getPopUpName();
        var link = ShopProfile.getPopUpLink();
        return (
            <a href={link} title={name}>
                <img src={url} alt={name} />
            </a>
        )
    }

    render() {
        var pic = '';
        if (ShopProfile.getPopUpLink() === '') {
            pic = this.popUpPic();
        } else {
            pic = this.popUpPicOnclick();
        }
        return (
            <div>
                <div id="overlay" onClick={() => this.popUpHide()}>
                </div>
                <div id="popUpBox">
                    {pic}
                </div>
                <div id="popUpBoxClose" onClick={() => this.popUpHide()}>
                    <b>
                        <i>X</i>
                    </b>
                </div>
            </div>
        )
    }

}